var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-icons-container",class:_vm.textClass},[(!!_vm.backAction || !!_vm.closeAction)?_c('icon',{staticClass:"action-icon",attrs:{"size":"24px","weight":"700","icon-name":!!_vm.backAction ? 'navigate_before' : 'close'},on:{"click":_vm.onActionClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }